import React from "react";
import TextInput from "./TextInput";
import TimeInput from "./TimeInput";
import TextNumberInput from "./TextNumberInput";
import SelectInput from "./SelectInput";
import FixButton from "./Button";
import Cookies from "universal-cookie";
import Utils from "../utils/utils";
import { EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import GetMaterie from "../services/getMaterie";
import GetAule from "../services/getAule";
import getCorsi from "../services/getCorsi";
import getCorso from "../services/getCorso";
import DeleteLezione from "../services/deleteLezione";
import UpdateAula from "../services/updateAula";
import updateLezione from "../services/updateLezione";
import addSessioneLezione from "../services/addSessioneLezione";
import updateSessioneLezione from "../services/updateSessioneLezione";
import getSessioniLezione from "../services/getSessioniLezione";
import deleteSessioniLezione from "../services/deleteSessioniLezione";
import CheckBox from "../widgets/CheckBox";
import moment from "moment";
import getInsegnanti from "../services/getInsegnanti";
import { Button } from "@material-ui/core";

export default class EditMeetingWidget extends React.Component {
  constructor(props) {
    super(props);

    this.selectRef = React.createRef();

    let date = this.props.meeting.data.split(" ")[0];
    let time = this.props.meeting.data.split(" ")[1];
    let hour = time.split(":")[0];
    let minutes = time.split(":")[1];

    let durata = this.props.meeting.durata / 60;

    let eventTime = Utils.roundTime(hour) + ":" + Utils.roundTime(minutes);

    // Gestione corretta del valore pagamento_quota
    const pagamentoQuotaValue = this.props.meeting.pagamento_quota;
    const isPagamentoQuota =
      pagamentoQuotaValue === "1" ||
      pagamentoQuotaValue === 1 ||
      pagamentoQuotaValue === true;

    console.log(
      "Valore pagamento_quota ricevuto:",
      pagamentoQuotaValue,
      "convertito in:",
      isPagamentoQuota
    );

    this.subjects = [];
    this.subjectsRepresentative = [];
    this.valueRepresentative = [];
    this.state = {
      visible: false,
      selected: "event",
      time: eventTime,
      date: date,
      durata: durata,
      slots: durata,
      editorState: EditorState.createEmpty(),
      altriCorsi: [],
      insegnanti: [],
      selectInsegnanti: [],
      selectedInsegnanti: [],
      pagamentoQuota: isPagamentoQuota,
      count: 0,
      divisaInMeta: false, // NUOVO
      sessioniLezione: [], // NUOVO
      // Prima metà
      selectedInsegnantiMeta1: [],
      selectedMaterieMeta1: [],
      selectedAuleMeta1: [],
      oraInizioMeta1: "09:30",
      oraFineMeta1: "13:00",
      // Seconda metà
      selectedInsegnantiMeta2: [],
      selectedMaterieMeta2: [],
      selectedAuleMeta2: [],
      oraInizioMeta2: "14:00",
      oraFineMeta2: "18:00",
    };
  }

  shouldComponentUpdate() {
    if (this.state.count > 2) return false;
    else return true;
  }

  componentDidUpdate() {
    this.setState({ count: this.state.count + 1 });
  }

  async componentDidMount() {
    let scheduleType = this.props.scheduleType;
    this.subjects = [];
    this.savedEnabled = false;
    this.brokersSelected = [];

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.materie = await GetMaterie(username, token);
    this.aule = await GetAule(username, token);
    this.corsi = await getCorsi(username, token);
    this.insegnanti = await getInsegnanti(username, token);

    this.altriCorsi = [];

    this.props.meeting.altri_corsi.split(";").forEach((i) => {
      if (i == "") return;
      var corso = this.corsi.find((temp) => temp.id == i);
      if (corso == undefined) return;
      this.altriCorsi.push({
        value: corso.id,
        label: corso.name,
      });
    });

    this.selectCorsi = [];
    this.selectAule = [];

    let currentAula = undefined;

    this.aule &&
      this.aule.forEach((b) => {
        this.selectAule.push({ value: b.id, label: b.nome });
        if (b.id == this.props.meeting.id_aula)
          currentAula = { value: b.id, label: b.nome };
      });

    this.corsi &&
      this.corsi.forEach((b) => {
        this.selectCorsi.push({ value: b.id, label: b.name });
      });

    this.strInsegnante = [];
    let insegnantiIds = this.props.meeting.id_insegnanti.split(",");
    let selectedInsegnanti = [];

    insegnantiIds.forEach((id) => {
      let insegnante = this.insegnanti.find((i) => i.id == id.trim());
      if (insegnante) {
        selectedInsegnanti.push({
          value: insegnante.id,
          label: `${insegnante.nome} ${insegnante.cognome}`,
        });

        this.strInsegnante.push(`${insegnante.nome} ${insegnante.cognome}`);
      }
    });

    let materieIds = this.props.meeting.id_materia.split(",");

    let selectedMaterie = [];

    materieIds.forEach((id) => {
      let materia = this.materie.find((i) => i.id == id.trim());
      if (materia) {
        selectedMaterie.push({
          value: materia.id,
          label: this.materie.note
            ? `${materia.nome} - ${materia.note}`
            : materia.materia,
        });
      }
    });

    // Carica le sessioni se la lezione è divisa
    const sessioni = await getSessioniLezione(
      username,
      token,
      this.props.meeting.id
    );
    const divisaInMeta = sessioni.length > 0;

    console.log("[EditMeetingWidget] Sessioni caricate:", sessioni);
    console.log("[EditMeetingWidget] Lezione divisa:", divisaInMeta);

    // Popola i dati delle sessioni se esistono
    let selectedInsegnantiMeta1 = [];
    let selectedMaterieMeta1 = [];
    let selectedAuleMeta1 = [];
    let oraInizioMeta1 = "09:30";
    let oraFineMeta1 = "13:00";

    let selectedInsegnantiMeta2 = [];
    let selectedMaterieMeta2 = [];
    let selectedAuleMeta2 = [];
    let oraInizioMeta2 = "14:00";
    let oraFineMeta2 = "18:00";

    if (divisaInMeta && sessioni.length >= 1) {
      // Ordina le sessioni per ordine crescente
      const sessioniOrdinate = sessioni.sort((a, b) => a.ordine - b.ordine);
      const sess1 = sessioniOrdinate[0]; // Prima sessione
      const sess2 = sessioniOrdinate[1]; // Seconda sessione (se esiste)

      // Prima metà
      if (sess1) {
        oraInizioMeta1 = sess1.ora_inizio || "09:30";
        oraFineMeta1 = sess1.ora_fine || "13:00";

        // Carica insegnanti
        if (sess1.id_insegnanti) {
          sess1.id_insegnanti.split(",").forEach((id) => {
            const ins = this.insegnanti.find((i) => i.id == id.trim());
            if (ins) {
              selectedInsegnantiMeta1.push({
                value: ins.id,
                label: `${ins.nome} ${ins.cognome}`,
              });
            }
          });
        }

        // Carica materie
        if (sess1.id_materia) {
          sess1.id_materia.split(",").forEach((id) => {
            const mat = this.materie.find((m) => m.id == id.trim());
            if (mat) {
              selectedMaterieMeta1.push({
                value: mat.id,
                label: mat.materia + (mat.note ? " - " + mat.note : ""),
              });
            }
          });
        }

        // Carica aule
        if (sess1.id_aula) {
          sess1.id_aula.split(",").forEach((id) => {
            const aula = this.aule.find((a) => a.id == id.trim());
            if (aula) {
              selectedAuleMeta1.push({
                value: aula.id,
                label: aula.nome,
              });
            }
          });
        }
      }

      // Seconda metà
      if (sess2) {
        oraInizioMeta2 = sess2.ora_inizio || "14:00";
        oraFineMeta2 = sess2.ora_fine || "18:00";

        // Carica insegnanti
        if (sess2.id_insegnanti) {
          sess2.id_insegnanti.split(",").forEach((id) => {
            const ins = this.insegnanti.find((i) => i.id == id.trim());
            if (ins) {
              selectedInsegnantiMeta2.push({
                value: ins.id,
                label: `${ins.nome} ${ins.cognome}`,
              });
            }
          });
        }

        // Carica materie
        if (sess2.id_materia) {
          sess2.id_materia.split(",").forEach((id) => {
            const mat = this.materie.find((m) => m.id == id.trim());
            if (mat) {
              selectedMaterieMeta2.push({
                value: mat.id,
                label: mat.materia + (mat.note ? " - " + mat.note : ""),
              });
            }
          });
        }

        // Carica aule
        if (sess2.id_aula) {
          sess2.id_aula.split(",").forEach((id) => {
            const aula = this.aule.find((a) => a.id == id.trim());
            if (aula) {
              selectedAuleMeta2.push({
                value: aula.id,
                label: aula.nome,
              });
            }
          });
        }
      }
    }

    this.setState({
      aula: currentAula,
      visible: this.props.visible,
      scheduleType: scheduleType,
      altriCorsi: this.altriCorsi,
      materia: this.materie,
      selectMaterie: this.selectMaterie,
      insegnanti: this.insegnanti,
      selectedInsegnanti: selectedInsegnanti,
      selectedMaterie: selectedMaterie,
      sessioniLezione: sessioni,
      divisaInMeta: divisaInMeta,
      // Dati sessioni
      selectedInsegnantiMeta1,
      selectedMaterieMeta1,
      selectedAuleMeta1,
      oraInizioMeta1,
      oraFineMeta1,
      selectedInsegnantiMeta2,
      selectedMaterieMeta2,
      selectedAuleMeta2,
      oraInizioMeta2,
      oraFineMeta2,
    });
  }

  onContentStateChange = (contentState) => {
    this.savedEnabled = true;
    console.log("as HTML:", draftToHtml(contentState));
    this.setState({ contentState });
  };

  componentDidUpdate() {
    console.log(this.state.selectMaterie);
  }

  addInsegnante() {
    this.setState((prevState) => ({
      selectedInsegnanti: [
        ...prevState.selectedInsegnanti,
        { value: null, label: "" },
      ],
    }));
  }

  handleInsegnanteChange(option, index) {
    let updatedInsegnanti = [...this.state.selectedInsegnanti];
    updatedInsegnanti[index] = option;
    this.setState({ selectedInsegnanti: updatedInsegnanti });
  }

  removeInsegnante(index) {
    this.setState((prevState) => {
      let updatedInsegnanti = [...prevState.selectedInsegnanti];
      updatedInsegnanti.splice(index, 1);
      return { selectedInsegnanti: updatedInsegnanti };
    });
  }

  addMateria() {
    this.setState((prevState) => ({
      selectedMaterie: [
        ...prevState.selectedMaterie,
        { value: null, label: "" },
      ],
    }));
  }

  handleMateriaChange(option, index) {
    let updatedMaterie = [...this.state.selectedMaterie];
    updatedMaterie[index] = option;
    this.setState({ selectedMaterie: updatedMaterie });
  }

  removeMateria(index) {
    this.setState((prevState) => {
      let updatedMaterie = [...prevState.selectedMaterie];
      updatedMaterie.splice(index, 1);
      return { selectedMaterie: updatedMaterie };
    });
  }

  // Metodi per gestire sessioni - Prima metà
  addInsegnanteMeta1 = () => {
    this.setState((prevState) => ({
      selectedInsegnantiMeta1: [...prevState.selectedInsegnantiMeta1, null],
    }));
  };

  removeInsegnanteMeta1 = (index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta1 = [...prevState.selectedInsegnantiMeta1];
      selectedInsegnantiMeta1.splice(index, 1);
      return { selectedInsegnantiMeta1 };
    });
  };

  handleInsegnanteMeta1Change = (option, index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta1 = [...prevState.selectedInsegnantiMeta1];
      selectedInsegnantiMeta1[index] = option;
      return { selectedInsegnantiMeta1 };
    });
  };

  addMateriaMeta1 = () => {
    this.setState((prevState) => ({
      selectedMaterieMeta1: [...prevState.selectedMaterieMeta1, null],
    }));
  };

  removeMateriaMeta1 = (index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta1 = [...prevState.selectedMaterieMeta1];
      selectedMaterieMeta1.splice(index, 1);
      return { selectedMaterieMeta1 };
    });
  };

  handleMateriaMeta1Change = (option, index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta1 = [...prevState.selectedMaterieMeta1];
      selectedMaterieMeta1[index] = option;
      return { selectedMaterieMeta1 };
    });
  };

  addAulaMeta1 = () => {
    this.setState((prevState) => ({
      selectedAuleMeta1: [...prevState.selectedAuleMeta1, null],
    }));
  };

  removeAulaMeta1 = (index) => {
    this.setState((prevState) => {
      const selectedAuleMeta1 = [...prevState.selectedAuleMeta1];
      selectedAuleMeta1.splice(index, 1);
      return { selectedAuleMeta1 };
    });
  };

  handleAulaMeta1Change = (option, index) => {
    this.setState((prevState) => {
      const selectedAuleMeta1 = [...prevState.selectedAuleMeta1];
      selectedAuleMeta1[index] = option;
      return { selectedAuleMeta1 };
    });
  };

  // Metodi per gestire sessioni - Seconda metà
  addInsegnanteMeta2 = () => {
    this.setState((prevState) => ({
      selectedInsegnantiMeta2: [...prevState.selectedInsegnantiMeta2, null],
    }));
  };

  removeInsegnanteMeta2 = (index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta2 = [...prevState.selectedInsegnantiMeta2];
      selectedInsegnantiMeta2.splice(index, 1);
      return { selectedInsegnantiMeta2 };
    });
  };

  handleInsegnanteMeta2Change = (option, index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta2 = [...prevState.selectedInsegnantiMeta2];
      selectedInsegnantiMeta2[index] = option;
      return { selectedInsegnantiMeta2 };
    });
  };

  addMateriaMeta2 = () => {
    this.setState((prevState) => ({
      selectedMaterieMeta2: [...prevState.selectedMaterieMeta2, null],
    }));
  };

  removeMateriaMeta2 = (index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta2 = [...prevState.selectedMaterieMeta2];
      selectedMaterieMeta2.splice(index, 1);
      return { selectedMaterieMeta2 };
    });
  };

  handleMateriaMeta2Change = (option, index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta2 = [...prevState.selectedMaterieMeta2];
      selectedMaterieMeta2[index] = option;
      return { selectedMaterieMeta2 };
    });
  };

  addAulaMeta2 = () => {
    this.setState((prevState) => ({
      selectedAuleMeta2: [...prevState.selectedAuleMeta2, null],
    }));
  };

  removeAulaMeta2 = (index) => {
    this.setState((prevState) => {
      const selectedAuleMeta2 = [...prevState.selectedAuleMeta2];
      selectedAuleMeta2.splice(index, 1);
      return { selectedAuleMeta2 };
    });
  };

  handleAulaMeta2Change = (option, index) => {
    this.setState((prevState) => {
      const selectedAuleMeta2 = [...prevState.selectedAuleMeta2];
      selectedAuleMeta2[index] = option;
      return { selectedAuleMeta2 };
    });
  };

  render() {
    if (this.props.meeting == undefined) return null;
    let st = Object.assign(
      { minHeight: "600px", display: this.state.visible ? "block" : "none" },
      mainClass
    );

    // Debugging per verificare lo stato del pagamentoQuota
    console.log("Stato pagamentoQuota nel render:", this.state.pagamentoQuota);

    return (
      <div style={st}>
        <div
          style={closeIcon}
          onClick={() => {
            this.setState({ visible: false });
            this.props.onDone();
          }}
        >
          X
        </div>
        <div
          style={{
            overflow: "scroll",
            marginTop: "10px",
            display: this.state.selected == "event" ? "block" : "none",
          }}
        >
          <div className="windowTitle" style={{ color: "black" }}>
            Modifica lezione
          </div>

          {this.state.divisaInMeta && this.state.sessioniLezione.length > 0 && (
            <div
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "5px",
                padding: "15px",
                margin: "15px 0",
                color: "#856404",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                ℹ️ Questa lezione è divisa in due metà
              </div>

              {this.state.sessioniLezione.map((sessione, index) => {
                const isMattinaSessione = sessione.ordine === 1;
                const sessioneLabel = isMattinaSessione
                  ? "🌅 Prima metà"
                  : "🌆 Seconda metà";
                const sessioneColor = isMattinaSessione ? "#2e7d32" : "#e65100";

                // Recupera i nomi degli insegnanti
                const insegnantiIds = sessione.id_insegnanti
                  ? sessione.id_insegnanti.split(",")
                  : [];
                const insegnantiNomi = insegnantiIds
                  .map((id) => {
                    const ins = this.state.insegnanti?.find(
                      (i) => i.id == id.trim()
                    );
                    return ins ? `${ins.nome} ${ins.cognome}` : id;
                  })
                  .filter(Boolean)
                  .join(", ");

                // Recupera i nomi delle materie
                const materieIds = sessione.id_materia
                  ? sessione.id_materia.split(",")
                  : [];
                const materieNomi = materieIds
                  .map((id) => {
                    const mat = this.state.materia?.find(
                      (m) => m.id == id.trim()
                    );
                    return mat ? mat.nome : id;
                  })
                  .filter(Boolean)
                  .join(", ");

                return (
                  <div
                    key={sessione.id}
                    style={{
                      marginTop: index > 0 ? "10px" : "0",
                      padding: "10px",
                      backgroundColor: "rgba(255,255,255,0.5)",
                      borderRadius: "5px",
                      borderLeft: `4px solid ${sessioneColor}`,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        color: sessioneColor,
                        marginBottom: "5px",
                      }}
                    >
                      {sessioneLabel}
                    </div>
                    <div style={{ fontSize: "13px", marginBottom: "3px" }}>
                      ⏰ Orario: {sessione.ora_inizio} - {sessione.ora_fine}
                    </div>
                    {insegnantiNomi && (
                      <div style={{ fontSize: "13px", marginBottom: "3px" }}>
                        👨‍🏫 Insegnanti: {insegnantiNomi}
                      </div>
                    )}
                    {materieNomi && (
                      <div style={{ fontSize: "13px" }}>
                        📚 Materie: {materieNomi}
                      </div>
                    )}
                  </div>
                );
              })}

              <div
                style={{
                  fontSize: "12px",
                  marginTop: "10px",
                  textAlign: "center",
                  opacity: 0.8,
                }}
              >
                Le presenze per questa lezione vengono gestite separatamente per
                ogni metà
              </div>
            </div>
          )}

          <div
            style={{
              textAlign: "center",
              color: "#a00308",
              fontWeight: "bold",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              const cookies = new Cookies();
              cookies.set("currentLezione", this.props.meeting.id, {
                path: "/",
              });
              cookies.set("currentMateria", this.strMateria, { path: "/" });

              window.location.href = "/#/app/gestionePresenze";
            }}
          >
            Gestione presenze
          </div>

          {/* Campo Data e Orario: nascosto quando la giornata è divisa a metà */}
          {!this.state.divisaInMeta && (
            <TextInput
              type="datetime-local"
              name={"Data"}
              value={this.state.date + "T" + this.state.time}
              onChange={(val) =>
                this.setState({
                  date: moment(val).format("yyyy-MM-DD"),
                  time: moment(val).format("HH:mm"),
                })
              }
            />
          )}

          <TextNumberInput
            name={"Durata"}
            value={this.state.slots}
            minValue="1"
            maxValue="10"
            onChange={(val) => this.setState({ slots: val })}
          />

          <CheckBox
            name="Pagamento Quota"
            checked={this.state.pagamentoQuota}
            value={this.state.pagamentoQuota}
            onChange={(val) => {
              console.log("Cambio valore checkbox a:", val);
              this.setState({ pagamentoQuota: val });
            }}
          />

          <CheckBox
            name="Dividi giornata in due metà (prima/seconda)"
            checked={this.state.divisaInMeta}
            value={this.state.divisaInMeta}
            onChange={(val) => {
              this.setState({ divisaInMeta: val });
            }}
          />

          {this.state.divisaInMeta ? (
            <>
              {/* Prima metà */}
              <div
                style={{
                  border: "2px solid #4caf50",
                  borderRadius: "8px",
                  padding: "15px",
                  marginTop: "20px",
                  marginBottom: "20px",
                  backgroundColor: "#f1f8f4",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "15px",
                    color: "#2e7d32",
                    textAlign: "center",
                  }}
                >
                  🌅 Prima metà
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <TextInput
                    type="time"
                    name="Ora Inizio Meta 1"
                    value={this.state.oraInizioMeta1}
                    onChange={(val) => this.setState({ oraInizioMeta1: val })}
                  />
                  <TextInput
                    type="time"
                    name="Ora Fine Meta 1"
                    value={this.state.oraFineMeta1}
                    onChange={(val) => this.setState({ oraFineMeta1: val })}
                  />
                </div>

                <Button
                  onClick={this.addInsegnanteMeta1}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#2e7d32",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Insegnante Meta 1
                </Button>

                {this.state.selectedInsegnantiMeta1.map((insegnante, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={insegnante}
                      name={`Insegnante Meta 1 - ${index + 1}`}
                      options={this.state.insegnanti.map((i) => ({
                        value: i.id,
                        label: `${i.nome} ${i.cognome}`,
                      }))}
                      onChange={(option) =>
                        this.handleInsegnanteMeta1Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeInsegnanteMeta1(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={this.addMateriaMeta1}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#2e7d32",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Materia Meta 1
                </Button>

                {this.state.selectedMaterieMeta1.map((materia, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={materia}
                      name={`Materia Meta 1 - ${index + 1}`}
                      options={this.state.materia.map((i) => ({
                        value: i.id,
                        label: i.materia + (i.note ? " - " + i.note : ""),
                      }))}
                      onChange={(option) =>
                        this.handleMateriaMeta1Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeMateriaMeta1(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={this.addAulaMeta1}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#2e7d32",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Aula Meta 1
                </Button>

                {this.state.selectedAuleMeta1.map((aula, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={aula}
                      name={`Aula Meta 1 - ${index + 1}`}
                      options={this.selectAule}
                      onChange={(option) =>
                        this.handleAulaMeta1Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeAulaMeta1(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}
              </div>

              {/* Seconda metà - Pomeriggio */}
              <div
                style={{
                  border: "2px solid #ff9800",
                  borderRadius: "8px",
                  padding: "15px",
                  marginTop: "20px",
                  marginBottom: "20px",
                  backgroundColor: "#fff8f0",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "15px",
                    color: "#e65100",
                    textAlign: "center",
                  }}
                >
                  🌆 Seconda metà
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <TextInput
                    type="time"
                    name="Ora Inizio Meta 2"
                    value={this.state.oraInizioMeta2}
                    onChange={(val) => this.setState({ oraInizioMeta2: val })}
                  />
                  <TextInput
                    type="time"
                    name="Ora Fine Meta 2"
                    value={this.state.oraFineMeta2}
                    onChange={(val) => this.setState({ oraFineMeta2: val })}
                  />
                </div>

                <Button
                  onClick={this.addInsegnanteMeta2}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#e65100",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Insegnante Meta 2
                </Button>

                {this.state.selectedInsegnantiMeta2.map((insegnante, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={insegnante}
                      name={`Insegnante Meta 2 - ${index + 1}`}
                      options={this.state.insegnanti.map((i) => ({
                        value: i.id,
                        label: `${i.nome} ${i.cognome}`,
                      }))}
                      onChange={(option) =>
                        this.handleInsegnanteMeta2Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeInsegnanteMeta2(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={this.addMateriaMeta2}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#e65100",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Materia Meta 2
                </Button>

                {this.state.selectedMaterieMeta2.map((materia, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={materia}
                      name={`Materia Meta 2 - ${index + 1}`}
                      options={this.state.materia.map((i) => ({
                        value: i.id,
                        label: i.materia + (i.note ? " - " + i.note : ""),
                      }))}
                      onChange={(option) =>
                        this.handleMateriaMeta2Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeMateriaMeta2(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={this.addAulaMeta2}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#e65100",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Aula Meta 2
                </Button>

                {this.state.selectedAuleMeta2.map((aula, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={aula}
                      name={`Aula Meta 2 - ${index + 1}`}
                      options={this.selectAule}
                      onChange={(option) =>
                        this.handleAulaMeta2Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeAulaMeta2(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <Button
                onClick={() => this.addInsegnante()}
                style={{
                  marginTop: "10px",
                  backgroundColor: "#a00308",
                  color: "white",
                  display: "block",
                }}
              >
                Aggiungi Insegnante
              </Button>

              {this.state.selectedInsegnanti &&
                this.state.selectedInsegnanti.map((insegnante, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      key={index}
                      ref={this.selectRef}
                      value={insegnante}
                      name={`Insegnante ${index + 1}`}
                      options={this.state.insegnanti.map((i) => ({
                        value: i.id,
                        label: `${i.nome} ${i.cognome}`,
                      }))}
                      onChange={(option) =>
                        this.handleInsegnanteChange(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeInsegnante(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

              <Button
                onClick={() => this.addMateria()}
                style={{
                  marginTop: "10px",
                  backgroundColor: "#a00308",
                  color: "white",
                  display: "block",
                }}
              >
                Aggiungi Materia
              </Button>

              {this.state.selectedMaterie &&
                this.state.selectedMaterie.map((materia, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      key={index}
                      ref={this.selectRef}
                      value={materia}
                      name={`Materia ${index + 1}`}
                      options={this.state.materia.map((i) => ({
                        value: i.id,
                        label: i.materia + (i.note ? " - " + i.note : ""),
                      }))}
                      onChange={(option) =>
                        this.handleMateriaChange(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeMateria(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

              <SelectInput
                ref={this.selectRef}
                value={this.state.altriCorsi}
                name={"Altri Corsi"}
                options={this.selectCorsi}
                isMulti={true}
                onChange={(option) => {
                  this.setState({
                    altriCorsi: option,
                  });
                }}
              />

              <SelectInput
                ref={this.selectRef}
                value={this.state.aula}
                name={
                  this.state.pagamentoQuota
                    ? "Aula (opzionale per pagamento quota)"
                    : "Aula"
                }
                options={this.selectAule}
                onChange={(option) => this.setState({ aula: option })}
              />
            </>
          )}
          <br />
          <br />
          <FixButton title={"Save"} callback={this.saveLezione.bind(this)} />
          <FixButton
            title={"Delete"}
            callback={this.deletePressed.bind(this)}
          />
        </div>
      </div>
    );
  }

  async saveBreak() {}

  checkInvestor(investors, id) {
    investors.map((v) => {
      if (v.id == id) return true;
    });
    return false;
  }

  async deletePressed() {
    if (window.confirm("Eliminare la lezione?")) {
      this.deleteMeeting(this.props.meeting.id);
    } else {
    }
  }

  async deleteMeeting(id) {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentEventId = cookies.get("currentEventId", { path: "/" });

    await DeleteLezione(username, token, id);

    this.props.onDone();
  }

  async saveLezione() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const id_corso = cookies.get("currentCourse", { path: "/" });

    if (!this.state.time) {
      alert("Inserire un orario");
      return;
    }

    if (!this.state.date) {
      alert("Inserire una data");
      return;
    }

    // Carica le informazioni del corso per la validazione della data
    try {
      const corso = await getCorso(username, token, id_corso);

      // Validazione: verifica che la data sia nel periodo del corso
      if (corso && corso.dateStart && corso.dateEnd) {
        const dataSelezionata = moment(this.state.date, "YYYY-MM-DD");
        const dataInizioCorso = moment(corso.dateStart, "YYYY-MM-DD");
        const dataFineCorso = moment(corso.dateEnd, "YYYY-MM-DD");

        if (
          !dataSelezionata.isBetween(
            dataInizioCorso,
            dataFineCorso,
            "day",
            "[]"
          )
        ) {
          alert(
            `La data inserita (${dataSelezionata.format(
              "DD/MM/YYYY"
            )}) deve essere nel periodo del corso:\n` +
              `${dataInizioCorso.format("DD/MM/YYYY")} - ${dataFineCorso.format(
                "DD/MM/YYYY"
              )}`
          );
          return;
        }
      }
    } catch (error) {
      console.error(
        "Errore nel caricamento del corso per la validazione:",
        error
      );
    }

    var id_materia = this.state.materia?.value || null;

    var altriCorsi = "";
    this.state.altriCorsi &&
      this.state.altriCorsi.forEach((i) => {
        altriCorsi += i.value + ";";
      });

    let idLezione = this.props.meeting.id;
    let idAula = this.state.aula ? this.state.aula.value : null;

    let selectedInsegnantiIds = this.state.selectedInsegnanti
      .filter((insegnante) => insegnante.value)
      .map((insegnante) => insegnante.value);

    let id_insegnanti = selectedInsegnantiIds.join(",");

    let selectedMaterieIds = this.state.selectedMaterie
      .filter((materia) => materia.value)
      .map((materia) => materia.value);

    let id_materie = selectedMaterieIds.join(",");

    let hour = this.state.time.split(":")[0];
    let minutes = this.state.time.split(":")[1];
    const durata = this.state.slots * 60;
    const pagamentoQuota = this.state.pagamentoQuota ? 1 : 0; // Convertiamo il booleano in 1/0 per il database

    var res = await updateLezione(
      username,
      token,
      idLezione,
      this.state.date,
      hour,
      minutes,
      durata,
      altriCorsi,
      this.props.meeting.id_corso,
      id_materie,
      idAula,
      id_insegnanti,
      pagamentoQuota // Aggiungiamo il parametro pagamentoQuota
    );
    if (res.result != "ok") {
      alert(res.description);
      return;
    }

    let newLesioneId = res.element_id;

    // Gestione sessioni per lezioni divise in due metà
    if (this.state.divisaInMeta) {
      // Carica le sessioni esistenti per questa lezione
      const sessioniEsistenti = await getSessioniLezione(
        username,
        token,
        newLesioneId
      );

      console.log("[EditMeetingWidget] Sessioni esistenti:", sessioniEsistenti);

      // Ordina le sessioni per ordine crescente
      const sessioniOrdinate = (sessioniEsistenti || []).sort(
        (a, b) => a.ordine - b.ordine
      );

      // Estrai gli ID degli insegnanti Meta1
      const insegnantiMeta1Ids = this.state.selectedInsegnantiMeta1
        .filter((ins) => ins && ins.value)
        .map((ins) => ins.value);

      // Estrai gli ID delle materie Meta1
      const materieMeta1Ids = this.state.selectedMaterieMeta1
        .filter((mat) => mat && mat.value)
        .map((mat) => mat.value);

      console.log(
        "[EditMeetingWidget] 🔍 materieMeta1Ids estratti per salvataggio:",
        materieMeta1Ids
      );
      console.log(
        "[EditMeetingWidget] 🔍 selectedMaterieMeta1 state:",
        this.state.selectedMaterieMeta1
      );

      // Estrai gli ID delle aule Meta1
      const auleMeta1Ids = this.state.selectedAuleMeta1
        .filter((aula) => aula && aula.value)
        .map((aula) => aula.value);

      // Usa la prima sessione nell'array ordinato (se esiste)
      const sessioneMeta1 = sessioniOrdinate[0];

      if (sessioneMeta1) {
        // AGGIORNA la sessione esistente invece di ricrearla
        console.log(
          "[EditMeetingWidget] Aggiorno sessione Meta1 esistente:",
          sessioneMeta1.id,
          "ordine:",
          sessioneMeta1.ordine
        );
        await updateSessioneLezione(
          username,
          token,
          sessioneMeta1.id, // Usa l'ID esistente
          sessioneMeta1.ordine, // Mantieni lo stesso ordine
          this.state.oraInizioMeta1,
          this.state.oraFineMeta1,
          insegnantiMeta1Ids,
          materieMeta1Ids,
          auleMeta1Ids
        );
      } else {
        // Crea la prima sessione solo se non esiste
        console.log("[EditMeetingWidget] Creo nuova sessione Meta1");
        await addSessioneLezione(
          username,
          token,
          newLesioneId,
          1, // ordine = 1 per la prima metà (compatibile con vecchio sistema)
          this.state.oraInizioMeta1,
          this.state.oraFineMeta1,
          insegnantiMeta1Ids,
          materieMeta1Ids,
          auleMeta1Ids
        );
      }

      // Estrai gli ID degli insegnanti Meta2
      const insegnantiMeta2Ids = this.state.selectedInsegnantiMeta2
        .filter((ins) => ins && ins.value)
        .map((ins) => ins.value);

      // Estrai gli ID delle materie Meta2
      const materieMeta2Ids = this.state.selectedMaterieMeta2
        .filter((mat) => mat && mat.value)
        .map((mat) => mat.value);

      console.log(
        "[EditMeetingWidget] 🔍 materieMeta2Ids estratti per salvataggio:",
        materieMeta2Ids
      );
      console.log(
        "[EditMeetingWidget] 🔍 selectedMaterieMeta2 state:",
        this.state.selectedMaterieMeta2
      );

      // Estrai gli ID delle aule Meta2
      const auleMeta2Ids = this.state.selectedAuleMeta2
        .filter((aula) => aula && aula.value)
        .map((aula) => aula.value);

      // Usa la seconda sessione nell'array ordinato (se esiste)
      const sessioneMeta2 = sessioniOrdinate[1];

      if (sessioneMeta2) {
        // AGGIORNA la sessione esistente invece di ricrearla
        console.log(
          "[EditMeetingWidget] Aggiorno sessione Meta2 esistente:",
          sessioneMeta2.id,
          "ordine:",
          sessioneMeta2.ordine
        );
        await updateSessioneLezione(
          username,
          token,
          sessioneMeta2.id, // Usa l'ID esistente
          sessioneMeta2.ordine, // Mantieni lo stesso ordine
          this.state.oraInizioMeta2,
          this.state.oraFineMeta2,
          insegnantiMeta2Ids,
          materieMeta2Ids,
          auleMeta2Ids
        );
      } else {
        // Crea la seconda sessione solo se non esiste
        console.log("[EditMeetingWidget] Creo nuova sessione Meta2");
        await addSessioneLezione(
          username,
          token,
          newLesioneId,
          2, // ordine = 2 per la seconda metà (compatibile con vecchio sistema)
          this.state.oraInizioMeta2,
          this.state.oraFineMeta2,
          insegnantiMeta2Ids,
          materieMeta2Ids,
          auleMeta2Ids
        );
      }

      // Elimina eventuali sessioni extra oltre le prime 2
      if (sessioniOrdinate.length > 2) {
        console.log(
          "[EditMeetingWidget] Elimino",
          sessioniOrdinate.length - 2,
          "sessioni duplicate"
        );
        for (let i = 2; i < sessioniOrdinate.length; i++) {
          // Qui dovresti chiamare un API per eliminare la sessione
          // await deleteSessioneLezione(username, token, sessioniOrdinate[i].id);
        }
      }
    } else {
      // Se divisaInMeta è false, elimina eventuali sessioni esistenti
      await deleteSessioniLezione(username, token, newLesioneId);
    }

    // Aggiorna l'aula solo se è stata selezionata (non opzionale per pagamenti quota)
    if (idAula && !this.state.divisaInMeta) {
      var res = await UpdateAula(
        username,
        token,
        newLesioneId,
        idAula,
        this.props.meeting.data,
        durata
      );
      if (res.result != "ok") {
        alert(res.description);
        return;
      }
    }
    alert("Lezione modificata");
    this.props.onDone();
  }

  handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ value: value });
  };
}

const menu = {
  position: "relative",
  top: "10px",
  display: "flex",
};

const menuVoice = {
  width: "50%",
  textAlign: "center",
  border: "1px solid black",
  cursor: "pointer",
};

const title = {
  top: "10xp",
  width: "100%",
  height: "40px",
  lineHeight: "40px",
  textAlign: "center",
};

const closeIcon = {
  position: "absolute",
  cursor: "pointer",
  right: 0,
  top: 0,
  padding: 10,
};

const mainClass = {
  position: "fixed",
  left: "35%",
  top: "10%",
  background: "#ffffff",
  border: "1px solid black",
  padding: "20px",
  overflow: "scroll",
  height: "600px",
  zIndex: 999,
};

const name = {};

const inputText = {
  width: "300px",
  padding: "10px",
};

const inputTextDisabled = {
  background: "#eeeeee",
  width: "300px",
  padding: "10px",
};
